










































import { Vue, Component, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IImage } from "@/store/types";

@Component
export default class UImageCarousel extends Vue {
  // Props
  @Prop({ default: () => [] })
  public images!: IImage[];
  // Methods
  public preview(full_url?: IImage["full_url"]) {
    if (!full_url) return;
    this.$store.dispatch(`data/${DataModules.IMAGES}/openImagePreviewModal`, {
      props: {
        imagePath: `${full_url}?size=original`
      }
    });
  }
}
